import { render, staticRenderFns } from "./PeopleStep.vue?vue&type=template&id=6a728f56&scoped=true"
import script from "./PeopleStep.vue?vue&type=script&lang=js"
export * from "./PeopleStep.vue?vue&type=script&lang=js"
import style0 from "./PeopleStep.vue?vue&type=style&index=0&id=6a728f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a728f56",
  null
  
)

export default component.exports